export function hasSubjectiveResponseAnswer(response) {
  const answers = Array.isArray(response?.answers) ? response.answers : [];
  return answers.some((entry) => {
    const value = entry?.answer;
    if (value === null || value === undefined) return false;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === "string") return value.trim() !== "";
    return true;
  });
}

/**
 * Hooper overview/edit scope: all enabled squad players, plus any responders
 * even if they lack load simulation data (timeinfo_date).
 */
export function buildHooperOverviewPlayers({
  playersForOverview = [],
  responses = [],
  selectedPosition = "All",
}) {
  let list = playersForOverview;

  if (Array.isArray(responses) && responses.length > 0) {
    const responderIds = new Set(
      responses
        .filter(hasSubjectiveResponseAnswer)
        .map((response) => String(response.player_id))
        .filter(Boolean)
    );

    if (responderIds.size > 0) {
      const responders = playersForOverview.filter((player) => responderIds.has(String(player.id)));
      const merged = new Map(list.map((player) => [String(player.id), player]));
      responders.forEach((player) => merged.set(String(player.id), player));
      list = [...merged.values()];
    }
  }

  if (selectedPosition === "All") return list;
  return list.filter((player) => player.position === selectedPosition);
}
